<a class="facet"  
	[routerLink]="['/hledat']" 
	[queryParams]="getChipQueryParams(chip)"
	queryParamsHandling=""
	matRipple
 >
	<span class="label">{{chip.entityLabel}}</span>
</a>